/**
 * casinetto-product-recommendations.js
 * ---------------------------------------------------------------------------
 * Lazy-loads product recommendations via Shopify's section rendering API.
 * Uses IntersectionObserver (400px lookahead) to fetch before the section
 * enters the viewport. Replaces skeleton placeholders with real cards.
 *
 * Data attributes (on the [data-product-recommendations] element):
 *   data-url          Base recommendations URL (routes.product_recommendations_url)
 *   data-product-id   Current product ID
 *   data-section-id   Section ID for section rendering API
 *   data-intent       "related" or "complementary"
 *   data-limit        Max products to show
 */
(function () {
  'use strict';

  var sections = document.querySelectorAll('[data-product-recommendations]');
  if (!sections.length) return;

  /* ---- Utility: re-create <script> tags so the browser executes them ---- */
  function activateScripts(container) {
    var scripts = container.querySelectorAll('script');
    scripts.forEach(function (oldScript) {
      var newScript = document.createElement('script');
      /* Copy all attributes */
      Array.from(oldScript.attributes).forEach(function (attr) {
        newScript.setAttribute(attr.name, attr.value);
      });
      if (!oldScript.src) {
        newScript.textContent = oldScript.textContent;
      }
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
  }

  sections.forEach(function (section) {
    var url       = section.dataset.url;
    var productId = section.dataset.productId;
    var sectionId = section.dataset.sectionId;
    var intent    = section.dataset.intent || 'related';
    var limit     = section.dataset.limit || '12';

    if (!url || !productId || !sectionId) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        observer.disconnect();

        var fetchUrl = url
          + '?product_id=' + encodeURIComponent(productId)
          + '&section_id=' + encodeURIComponent(sectionId)
          + '&intent=' + encodeURIComponent(intent)
          + '&limit=' + encodeURIComponent(limit);

        fetch(fetchUrl)
          .then(function (res) {
            if (!res.ok) throw new Error('Recommendations fetch failed: ' + res.status);
            return res.text();
          })
          .then(function (html) {
            /* Parse the response to extract the section's inner HTML */
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var newSection = doc.querySelector('[data-product-recommendations]');

            if (!newSection) {
              /* Response did not contain the expected element -- hide section */
              section.style.display = 'none';
              return;
            }

            /* Check if the response wants to hide the section (0 products, 0 fallback) */
            var hideStyle = newSection.querySelector('style');
            if (hideStyle && hideStyle.textContent.indexOf('display: none') !== -1) {
              section.style.display = 'none';
              return;
            }

            /* Replace the container content (heading + rail) */
            var container = section.querySelector('.c-container');
            var newContainer = newSection.querySelector('.c-container');
            if (container && newContainer) {
              container.innerHTML = newContainer.innerHTML;
            }

            /* Remove the rail-scroll-init flag so rail-scroll.js can re-init */
            delete section.dataset.railScrollInit;

            /* Re-create script tags so they execute (rail-scroll.js, pcard JS) */
            activateScripts(section);
          })
          .catch(function (err) {
            /* Hide section gracefully on error */
            console.error('[casinetto-product-recommendations]', err);
            section.style.display = 'none';
          });
      });
    }, {
      rootMargin: '0px 0px 400px 0px'
    });

    observer.observe(section);
  });
})();
